import { z } from 'zod';

import { acnPattern } from '@paid-ui/regexps/acn';

export const acnSchema = z
  .string()
  .min(1, 'Required field')
  .regex(acnPattern, 'ACN must be 9 digits');

export const optionalACNSchema = z
  .string()
  .regex(acnPattern, 'ACN must be 9 digits')
  .or(z.literal(''));
